import React, { useState, useEffect } from "react";

import { GiEightBall, GiFishing, GiRooster, GiTakeMyMoney } from "react-icons/gi";
import { BiHomeAlt, BiChat, BiDice5, BiHelpCircle, BiCategory, BiTimeFive } from "react-icons/bi";
import { HiOutlineSpeakerphone, HiOutlineExclamationCircle } from "react-icons/hi";
import { PiUsersThreeLight, PiPuzzlePiece } from "react-icons/pi";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import { BsBarChartLine, BsPen, BsRocketTakeoff } from "react-icons/bs";
import { MdOutlineFactCheck, MdOutlineVideogameAsset, MdSportsSoccer } from "react-icons/md";
import { TbCards, TbCrystalBall } from "react-icons/tb";
import { FaRegFileAlt } from "react-icons/fa";
import { LuTimerReset } from "react-icons/lu";


const IconTag = ({ iconTagName }) => {
  // State for the icon
  const [IconTagName, setIconTagName] = useState(null);

  useEffect(() => {
    const loadIcon = async () => {
      try {
        // Icon library class list
        const iconClassList = {
          fa: { 'FaRegFileAlt': FaRegFileAlt },
          bs: { 'BsRocketTakeoff': BsRocketTakeoff, "BsPen": BsPen, 'BsBarChartLine': BsBarChartLine },
          bi: {
            'BiHomeAlt': BiHomeAlt,
            'BiChat': BiChat,
            'BiDice5': BiDice5,
            'BiHelpCircle': BiHelpCircle,
            'BiCategory': BiCategory,
            'BiTimeFive': BiTimeFive
          },
          lia: { 'LiaMoneyCheckAltSolid': LiaMoneyCheckAltSolid },
          md: { 'MdOutlineVideogameAsset': MdOutlineVideogameAsset, 'MdSportsSoccer': MdSportsSoccer, 'MdOutlineFactCheck': MdOutlineFactCheck },
          tb: {
            'TbCards': TbCards,
            'TbCrystalBall': TbCrystalBall
          },
          gi: { 'GiEightBall': GiEightBall, 'GiFishing': GiFishing, 'GiTakeMyMoney': GiTakeMyMoney, 'GiRooster': GiRooster },
          hi: { 'HiOutlineSpeakerphone': HiOutlineSpeakerphone, 'HiOutlineExclamationCircle': HiOutlineExclamationCircle },
          pi: {
            'PiUsersThreeLight': PiUsersThreeLight,
            'PiPuzzlePiece': PiPuzzlePiece
          },
          lu: {
            "LuTimerReset": LuTimerReset
          }
        };

        // Get initial two or three letter tag identifier
        let tagIdentifier = iconTagName?.slice(0, 3).toLowerCase();
        if (!iconClassList?.[tagIdentifier]) {
          tagIdentifier = iconTagName?.slice(0, 2).toLowerCase();
        }

        // Load the correct icons module
        if (tagIdentifier && iconClassList?.[tagIdentifier]) {
          const iconsModule = await iconClassList?.[tagIdentifier];
          const IconComponent = iconsModule?.[iconTagName];

          if (IconComponent) {
            setIconTagName(() => IconComponent); // Set the component if found
          } else {
            console.warn(`Icon "${iconTagName}" not found in "${tagIdentifier}" icons`);
          }
        }
      } catch (error) {
        console.error("Error loading icons module:", error);
      }
    };
    loadIcon();
  }, [iconTagName]);

  // Render icon if loaded, otherwise null
  return IconTagName ? <IconTagName /> : null;
};

export default IconTag;
